module.exports = {
  'c1': {
    display: 'Commitment',
    className: 'commitment',
    src: 'commitment'
  },
  'p1': {
    display: 'Privacy',
    className: 'privacy',
    src: 'privacy'
  },
  'f1': {
    display: 'Freedom of Expression',
    className: 'expression',
    src: 'freedom-of-expression'
  }
};
